import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

const PaymentCancelled = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-sky-50 to-emerald-50">
      <Card className="max-w-md w-full mx-4 border-amber-200">
        <CardContent className="pt-6 text-center">
          <div className="bg-amber-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
            <XCircle className="h-10 w-10 text-amber-600" />
          </div>
          <h2 className="text-2xl font-bold text-slate-900 mb-2">Payment Cancelled</h2>
          <p className="text-slate-600 mb-6">
            Your payment was cancelled. No charges have been made to your account.
          </p>
          <p className="text-sm text-slate-600 mb-6">
            If you'd like to complete your booking, please try again or contact us for assistance.
          </p>
          <div className="space-y-3">
            <Link to="/contact">
              <Button className="w-full bg-sky-600 hover:bg-sky-700">
                Contact Us
              </Button>
            </Link>
            <Link to="/">
              <Button variant="outline" className="w-full">
                Return to Home
              </Button>
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentCancelled;